import { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';

// project imports
import { useAuth } from '@clerk/clerk-react';
import { getDynamicDashboardPath } from 'config';
import { GuardProps } from 'types';
import { captureCampaignParamsFromUrl } from 'utils/auth/campaignAttribution';

// ==============================|| GUEST GUARD ||============================== //

/**
 * Guest guard for routes having no auth required
 * @param {PropTypes.node} children children element/node
 */

export default function GuestGuard({ children }: GuardProps) {
  const { isSignedIn } = useAuth();
  const location = useLocation();

  //* ייחוס קמפיינים: קליטת printid/utm_* מה-URL בכל מסך אורח (לוגין/הרשמה).
  //* נשמר ב-localStorage ונשלח לשרת רק אחרי כניסה מוצלחת (loadAppUserProfile).
  useEffect(() => {
    captureCampaignParamsFromUrl();
  }, [location.search]);
  const hasCompany = Boolean(localStorage.getItem('companyId'));
  const isAcceptInviteRoute = location.pathname === '/accept-invite';

  if (isAcceptInviteRoute) {
    return children;
  }

  if (isSignedIn) {
    if (!hasCompany) {
      return <Navigate to="/company-onboarding" replace />;
    }

    //* popup של תוסף הפיירברי: אחרי login חוזרים ל-plugin-auth להשלמת מסירת הטוקן.
    //* הדגל ב-sessionStorage (per-window) ולכן טאבים רגילים לא מושפעים.
    let pluginAuthReturn = false;
    try {
      pluginAuthReturn = sessionStorage.getItem('pluginAuthReturn') === '1';
    } catch {
      /* storage חסום — מתנהגים כרגיל */
    }
    if (pluginAuthReturn) {
      return <Navigate to="/plugin-auth" replace />;
    }

    return <Navigate to={getDynamicDashboardPath()} replace />;
  }

  return children;
}
